import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option"];

  toggleOption(e) {
    this.optionTargets.forEach((element) => {
      element.removeAttribute("open");
    });
    e.currentTarget.setAttribute("open", "");
  }
}
